import React, { Component } from "react";
import { Route, Switch, HashRouter } from "react-router-dom";
import Home from "../pages/home/HomeScreen";
import ProjectScreen from "../pages/projects/ProjectScreen";
import OurTeamScreen from "../pages/ourTeam/OurTeam";
import ContactForm from "../pages/contactus/ContactUs";

export default class Routes extends Component<any> {
  render() {
    return (
      <div>
        <HashRouter basename="/">
          <Switch>
            <Route
              exact
              path="/"
              render={(props) => <Home {...props} theme={this.props.theme} />}
            />
            <Route
              path="/projects"
              render={(props) => (
                <ProjectScreen {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="/our-team"
              render={(props) => (
                <OurTeamScreen {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="/contact-us"
              render={(props) => (
                <ContactForm {...props} theme={this.props.theme} />
              )}
            />
          </Switch>
        </HashRouter>
      </div>
    );
  }
}
